import { render } from "./PolicyHistoryPopup.vue?vue&type=template&id=226fc3b2&scoped=true"
import script from "./PolicyHistoryPopup.vue?vue&type=script&lang=js"
export * from "./PolicyHistoryPopup.vue?vue&type=script&lang=js"

import "./PolicyHistoryPopup.vue?vue&type=style&index=0&id=226fc3b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226fc3b2"]])

export default __exports__